export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_LOGGED_IN = "SET_LOGGED_IN";
export const SET_CURRENT_PATTERN = "SET_CURRENT_PATTERN";
export const SET_PATTERN_NAME = "SET_PATTERN_NAME";
export const SET_COLOR = "SET_COLOR";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER_PATTERNS = "UPDATE_USER_PATTERNS";
export const SET_MODEL = "SET_MODEL";
export const TOGGLE_MODAL = "TOGGLE_MODAL";



// WEBPACK FOOTER //
// ./src/actions/types.js